<style lang="scss" scope>
.top-nav {
	background-color: #ebf1f6;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;

	&-one {
		padding: 0px 30px 0px 20px;
		height: 70px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid #eee;

		.tab_info_tops {
			cursor: pointer;
			display: flex;
			align-items: center;

			.item_content {
				width: 100px;
				height: 70px;
				background: #ebf1f6;
				line-height: 70px;
				text-align: center;
				color: #606266;
				font-size: 14px;

				&:hover {
					background: rgba(255, 255, 255, 0.5);
				}
			}

			.item_active_content {
				background: rgba(255, 255, 255, 0.5);
			}
		}

		.logo-wp {
			position: relative;
			cursor: pointer;
			width: 197px;
			text-align: center;

			&-adorn {
				position: absolute;
				bottom: -29px;
				right: 60px;
			}
		}

		.open {
			margin-left: 52px;
			margin-bottom: 1px;
			cursor: pointer;
		}
	}

	&-breadcrumb {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		padding: 20px 30px;

		.text {
			padding-right: 23px;
			background: url("../../../assets/images/main-icon-home2.png") no-repeat
				right 0px;
			margin-left: 10px;
			font-size: 14px;
			font-weight: 700;
			text-align: right;
		}

		.el-breadcrumb__inner {
			color: #333;
			font-weight: bold;
		}

		.el-breadcrumb__inner.is-link,
		.el-breadcrumb__inner a {
			color: #e84d4c;
			font-weight: bold;
		}

		.el-breadcrumb__separator {
			color: #333;
			margin: 0 2px 0 5px;
			font-weight: bold;
		}
	}

	.public-message {
		position: relative;
		top: auto;
		right: auto;

		&-left {
			i {
				color: #e84d4c;
				// background: linear-gradient(#e84d4c 0%, #ffa66a 100%);
				background: transparent;
				border: 0;
			}

			span {
				color: #868686;
			}
		}

		&-right {
			.dropdown-link {
				color: #000;
			}

			.thumb img {
				border: 2px solid #fff;
			}
		}

		.message {
			fill: #868686 !important;
		}
	}
}

//breadcrumb transition
.breadcrumb-enter-active,
.breadcrumb-leave-active {
	transition: all 0.5s;
}

.breadcrumb-enter,
.breadcrumb-leave-active {
	opacity: 0;
	transform: translateX(20px);
}

.breadcrumb-move {
	transition: all 0.5s;
}

.breadcrumb-leave-active {
	position: absolute;
}

/*修改密码弹窗*/
.f_titel {
	width: 100%;
	height: 50px;
	line-height: 50px;
	font-size: 18px;
	color: #333333;
	text-align: center;
	border-bottom: 1px solid #f0f0f0;
}

.f_ul {
	width: 100%;
	//height: 100px;
}

.f_ul_by {
	width: 100%;
	height: 50px;
	line-height: 50px;
	display: flex;
	//border-bottom: 1px solid #F0F0F0;
}

.f_ul_mun {
	width: 100px;
	color: #666666;
	font-size: 15px;
	text-align: right;
}

.f_ul_logistics {
	min-width: 249px;
	color: #333333;
	font-size: 15px;
}

input {
	border: 1px solid #e6e8ec;
	border-radius: 3px;
	font-size: 14px;
	font-weight: 400;
	color: #333;
	width: 249px;
	height: 43px;
	border: 1px solid #e6e8ec;
	border-radius: 3px;
	padding: 13px 15px 13px 42px;
	box-sizing: border-box;
	outline: none;
	background-position: 15px center;
	background-repeat: no-repeat;
	-webkit-box-shadow: 0 0 0 1000px white inset;
}
.div_txt_tas {
	margin-left: -20px;
	font-size: 18px;
	font-weight: 700;
}
</style>

<template>
	<section class="top-nav">
		<div class="top-nav-one">
			<div class="tab_info_tops">
				<!--        @click="changBox"-->
				<div class="logo-wp">
					<div class="div_txt_tas">Micro Synaesthesia</div>
					<!-- <img v-for="(item,index) in menuList" :key="index" v-if="reporId==item.menuId" @click="changSystem(item.menuId,item)" style="object-fit: contain;width:150px " src="../../../assets/images/top_ico.png"> -->
				</div>
				<div
					v-for="(item, index) in menuList"
					:key="index"
					class="item_content"
					@click="changSystem(item.menuId, item)"
					:class="{ item_active_content: reporId == item.menuId }"
				>
					{{ item.name }}
				</div>
			</div>
			<div class="public-message">
				<div
					class="public-message-left"
					@click="handleGoTo('LOG_MESSAGE')"
				></div>
				<div class="public-message-right">
					<div class="thumb">
						<img :src="info.head" alt="" />
					</div>
					<el-dropdown @command="handleCommand" class="dropdown">
						<span class="dropdown-link">
							{{ info.name }}<i class="el-icon-arrow-down el-icon--right"></i>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="personal"
								><i class="el-icon-user"></i> 个人中心
							</el-dropdown-item>
							<el-dropdown-item command="password"
								><i class="el-icon-key"></i> 登录密码
							</el-dropdown-item>
							<el-dropdown-item
								v-if="info.operateStatus == 1"
								command="operation"
								><i class="el-icon-setting"></i> 操作密码
							</el-dropdown-item>
							<el-dropdown-item command="loginOut"
								><i class="el-icon-switch-button"></i> 退出登录
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>
		</div>

		<el-dialog
			:show-close="false"
			width="400px"
			class="nav_dialog"
			:title="modificationType == 'signIn' ? '修改登录密码' : '修改操作密码'"
			align="center"
			:close-on-click-modal="false"
			z-index="3"
			:visible.sync="alterPassword"
		>
			<ul class="f_ul">
				<li class="f_ul_by">
					<h3 class="f_ul_mun">账号：</h3>
					<div
						class="f_ul_logistics"
						style="text-align: left"
						v-if="info.account && info.account.account"
					>
						{{ info.account.account }}
					</div>
				</li>
				<li class="f_ul_by">
					<h3 class="f_ul_mun">姓名：</h3>
					<div class="f_ul_logistics" style="text-align: left">
						{{ info.name }}({{ info.number }})
					</div>
				</li>
				<li class="f_ul_by">
					<h3 class="f_ul_mun">原密码：</h3>
					<div class="f_ul_logistics">
						<input
							type="password"
							v-model="params.opwd"
							placeholder="请输入原密码"
						/>
					</div>
				</li>
				<li class="f_ul_by">
					<h3 class="f_ul_mun">新密码：</h3>
					<div class="f_ul_logistics">
						<input
							type="password"
							v-model="params.npwd"
							placeholder="请输入新密码"
						/>
					</div>
				</li>
				<li class="f_ul_by">
					<h3 class="f_ul_mun">确认新密码：</h3>
					<div class="f_ul_logistics">
						<input
							type="password"
							v-model="confirmNewPassword"
							placeholder="请输入原密码"
						/>
					</div>
				</li>
			</ul>
			<div
				slot="footer"
				class="dialog-footer"
				style="
					display: flex;
					justify-content: space-between;
					width: 75%;
					margin: 0 auto;
				"
			>
				<el-button
					plain
					v-if="info.account && info.account.upwd != 1"
					@click="claerShow"
					style="width: 110px"
					>取 消
				</el-button>

				<el-button
					plain
					type="primary"
					@click="confirmLogistics"
					style="width: 110px"
					>确 定
				</el-button>
				<el-button
					plain
					v-if="info.account && info.account.upwd == 1"
					type="danger"
					@click="handleCommand('loginOut')"
					style="width: 110px"
					>退出登录
				</el-button>
			</div>
		</el-dialog>

		<el-dialog
			title="个人中心"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			width="760px"
			class="public-dialog"
		>
			<div class="public-dialog-form">
				<el-form ref="ruleForm" label-width="80px" :rules="rules" :model="info">
					<el-form-item label="头像：">
						<div class="diplay" style="margin-right: 10px">
							<div class="screenshot">
								<span
									v-for="(imgUrl, index) in srcList"
									:key="index"
									class="slideshow"
								>
									<el-image
										style="width: 75px; height: 75px; border-radius: 6px"
										:src="imgUrl"
										fit="cover"
										@click="getPolicy"
									/>
								</span>
								<div
									class="up-btn"
									style="width: 75px; height: 75px; line-height: 80px"
									@click="getPolicy"
									v-if="isMoer && !info.head"
								>
									<i class="el-icon-plus"></i>
								</div>
							</div>
							<input
								type="file"
								ref="file"
								@change="getFile"
								accept="image/png,image/jpg"
							/>
						</div>
					</el-form-item>
					<!-- 新增  修改 -->
					<div style="display: flex; align-items: center">
						<el-form-item
							label="账号："
							prop="account"
							style="margin-right: 176px"
						>
							<span>{{ info.account ? info.account.account : "" }} </span>
						</el-form-item>
						<el-form-item class="item" label="工号：">
							<span>{{ info.number }} </span>
						</el-form-item>
					</div>
					<el-row>
						<el-col :span="10">
							<el-form-item label="姓名：" prop="name">
								<el-input
									type="text"
									v-model="info.name"
									clearable
									style="width: 200px"
									placeholder="姓名"
								></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="13">
							<el-form-item label="手机号：" prop="phone">
								<el-input
									clearable
									v-model="info.phone"
									placeholder="11位手机号码"
								></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="10">
							<el-form-item class="item" label="性别：" prop="sex">
								<el-radio v-model="info.sex" :label="1">男</el-radio>
								<el-radio v-model="info.sex" :label="2">女</el-radio>
							</el-form-item>
						</el-col>
						<el-col :span="13">
							<el-form-item label="邮箱：" prop="email">
								<el-input
									clearable
									v-model="info.email"
									placeholder="邮箱"
								></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="10">
							<el-form-item label="组织：">
								<span>{{ info.org ? info.org.name : "" }}</span>
							</el-form-item>
						</el-col>
						<el-col :span="13">
							<el-form-item label="岗位：">
								<span>{{ info.post ? info.post.name : "" }}</span>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</div>
			<span slot="footer" class="public-dialog-footer">
				<el-button size="medium" @click="dialogVisible = false"
					>取 消</el-button
				>
				<el-button size="medium" type="primary" @click="handleEdit"
					>提 交</el-button
				>
			</span>
		</el-dialog>
	</section>
</template>

<script>
import WdSet from "../../topic/resultSet/wdSet";
import { ossUpload } from "@utils/filters/upload";
import bus from "../../../assets/js/eventBus";

export default {
	name: "TopNav",
	components: { WdSet },
	data() {
		return {
			reporId: 0,
			breadcrumb: [],
			info: {},
			userInfo: JSON.parse(localStorage.getItem("userInfo")),
			countNum: 0,
			alterPassword: false,
			confirmNewPassword: "",
			modificationType: "signIn",
			params: {
				id: "",
				npwd: "",
				opwd: "",
			},
			dialogVisible: false,
			isMoer: true,
			srcList: [],
			rules: {
				name: [{ required: true, message: "请填写姓名" }],
				phone: [
					{ required: true, message: "请填写手机号码" },
					{ min: 11, max: 11, message: "手机号为11个字符", trigger: "change" },
					{
						pattern:
							/^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
						message: "请输入正确的手机号码",
					},
				],
			},
			oldInfo: {},
			menuList: [],
		};
	},

	mounted() {
		this.getLoginInfo();
		this.getBreadcrumb(this.$store.state.routerData, this.$route);
		this.breadcrumb.reverse(); //倒序
		this.menuData();
	},

	created() {},
	watch: {
		dialogVisible() {
			if (this.dialogVisible == false) {
				this.info = {};
				this.srcList.splice(0, 1);
				this.info = JSON.parse(JSON.stringify(this.oldInfo));
				this.srcList.push(this.oldInfo.head);
			}
		},
		$route(to, from) {
			this.breadcrumb = [];
			this.getBreadcrumb(this.$store.state.routerData, this.$route);
			this.breadcrumb.reverse(); //倒序
		},
	},

	methods: {
		changBox() {
			this.$router.push({
				name: "HOME_CHLID",
			});
			// this.reporId = 1
			// if (window.sessionStorage.getItem('tt_menuId')) {
			//   if (window.sessionStorage.getItem('tt_menuId') == '00001') {
			//     this.$router.push({
			//       name: 'HOME_CHLID'
			//     })
			//   } else {
			//     this.$router.push({
			//       name: 'LAUNCH_CHLID'
			//     })
			//   }
			// }
		},

		async menuData() {
			const { data: resData } = await this.$get("/menus", this.params, {
				headers: {
					isLoading: true,
				},
			});
			if (resData.result != 200) {
				this.$store.commit("setJurisdiction");
				return;
			}
			this.menuList = resData.data;
			if (window.sessionStorage.getItem("tt_menuId")) {
				this.reporId = window.sessionStorage.getItem("tt_menuId");
				window.sessionStorage.setItem("tt_menuId", this.reporId);
			} else {
				this.reporId = resData.data[0].menuId;
			}
		},

		changSystem(e, item) {
			if (item.view) {
				this.reporId = e;
				window.sessionStorage.setItem("tt_menuId", e);
				bus.$emit("sendBybus", this.reporId);
				this.$router.push({
					name: item.view,
				});
			}
		},

		handleEdit() {
			let obj = {
				email: this.info.email,
				head: this.info.head,
				name: this.info.name,
				phone: this.info.phone,
				sex: this.info.sex,
			};
			this.$confirm("确认提交修改, 是否继续?", "提示", {
				type: "info",
			}).then(async () => {
				const { data: resData } = await this.$put("/personal/info", obj, {
					headers: {
						isLoading: true,
					},
				});
				if (resData.result != 200) return;
				// this.getstaffListTree(); //重新获取数据
				this.getLoginInfo();

				this.dialogVisible = false; //弹窗隐藏
				this.$message.success("修改成功!");
			});
		},
		getPolicy() {
			this.$refs.file.dispatchEvent(new MouseEvent("click"));
		},

		async getFile() {
			const that = this;
			const { data: resData } = await this.$get("/aliyun/oss/sign", {
				headers: {
					isLoading: true,
				},
			});
			if (resData.result != 200) return;
			const addRoutes = await ossUpload(
				that.$refs.file.files[0],
				resData.data,
				"one", //'more','one'
				this.srcList
			);
			this.isMoer = false;
			this.srcList = addRoutes;
			this.info.head = this.srcList[0];
		},
		/*
      登录信息
     */
		async getLoginInfo() {
			const { data: resData } = await this.$get("/info", {});
			this.info = resData.data;
			this.oldInfo = JSON.parse(JSON.stringify(resData.data));
			this.srcList[0] = resData.data.head;
			this.params.id = resData.data.id;
			this.$store.commit("setUserInfo", this.info);
			if (resData.data.account.upwd == 1) {
				this.alterPassword = true;
			}
		},
		/**
		 * 面包屑
		 */
		getBreadcrumb(routes, route) {
			routes.forEach((item) => {
				if (
					route.meta.parent == item.name ||
					route.name.indexOf(item.name) != -1
				) {
					this.breadcrumb.push(item);
				}
				if (item.children) this.getBreadcrumb(item.children, route);
			});
		},

		/**
		 * 发布事项
		 */
		async setPublishedEvent() {
			const { data: resData } = await this.$get(
				"/homepage/homepage/publishedEvent",
				{}
			);
		},

		/**
		 * 处理全屏
		 */
		async handleScreen() {
			this.$store.commit("setMeunShow", !this.$store.getters.getMeunShow);
		},

		/**
		 * 跳转
		 */

		/**
		 * 处理下拉菜单事件
		 */
		async handleCommand(command) {
			switch (command) {
				//退出登录
				case "loginOut":
					this.$confirm("是否确认退出登录？", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
						.then(async () => {
							//
							const { data: resData } = await this.$post("/logout", {
								headers: {
									isLoading: true,
								},
							});
							if (resData.result != 200) return;
							localStorage.removeItem("userInfo");
							sessionStorage.removeItem("tt_menuId");
							//清空路由
							location.reload();
						})
						.catch(() => {});
					break;
				case "password":
					this.alterPassword = true;
					this.modificationType = "signIn";
					break;
				case "operation":
					this.alterPassword = true;
					this.modificationType = "operation";
					break;
				case "personal":
					this.personalInfo();
					break;
			}
		},
		personalInfo() {
			this.dialogVisible = true;
		},
		//数据清空
		dataEmptying() {
			this.alterPassword = false;
			localStorage.removeItem("userInfo");
			//清空路由
			location.reload();
			this.params.npwd = "";
			this.params.opwd = "";
			this.confirmNewPassword = "";
			this.$message.success("修改成功!");
		},
		claerShow() {
			this.params.npwd = "";
			this.params.opwd = "";
			this.confirmNewPassword = "";
			this.alterPassword = false;
			this.show_alter = false;
		},
		// 修改密码确定
		async confirmLogistics() {
			if (!this.params.opwd) {
				this.$message.error("请输入原密码");
			} else if (!this.params.npwd) {
				this.$message.error("请输入新密码");
			} else if (!this.confirmNewPassword) {
				this.$message.error("请输入确认密码");
			} else if (this.confirmNewPassword != this.params.npwd) {
				this.$message.error("新密码和确认密码不一致");
			} else {
				if (this.modificationType == "signIn") {
					const { data: resData } = await this.$put(
						"/staff/update/pwd",
						this.params,
						{
							headers: {
								isLoading: true,
							},
						}
					);
					if (resData.result != 200) return;
					this.$message.success("操作成功");
					this.claerShow();
				} else {
					const { data: resData } = await this.$put(
						"/staff/update/operate/pwd",
						this.params,
						{
							headers: {
								isLoading: true,
							},
						}
					);
					if (resData.result != 200) return;
					this.$message.success("操作成功");
					this.claerShow();
				}
			}
		},
	},
};
</script>
